import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../../context/LangContext';
import { SITE_CONFIG } from '../../config/siteConfig';
import { fonts } from '../../styles/tokens';
import styles from './Footer.module.css';

function Footer() {
  const { t } = useLang();
  const { brand, socialLinks } = SITE_CONFIG;

  const columns = [
    {
      title: t.footer.platform,
      links: [
        { label: t.nav.home,    to: '/' },
        { label: t.faq.label,   to: '/#faq' },
        { label: t.pricing.label, to: '/#pricing' },
      ],
    },
    {
      title: t.footer.legal,
      links: [
        { label: t.nav.terms,   to: '/terms' },
        { label: t.nav.privacy, to: '/privacy' },
        { label: 'Delete Account', to: '/delete-account' },
      ],
    },
    {
      title: t.footer.company,
      links: [
        { label: t.nav.about,   to: '/about' },
        { label: t.nav.contact, to: '/contact' },
      ],
    },
  ];

  return (
    <footer className={styles.footer}>
      <div className="container">
        <div className={styles.grid}>
          {/* Brand column */}
          <div>
            <Link to="/" className={styles.logoRow}>
              <div className={styles.logoIcon}>B</div>
              <span style={{ fontFamily: fonts.display, fontWeight: 800, fontSize: 18, color: '#fff', letterSpacing: 2 }}>
                {brand.name}
              </span>
            </Link>
            <p style={{ fontFamily: fonts.body, fontSize: 13, color: 'rgba(255,255,255,0.35)', lineHeight: 1.6, margin: '0 0 18px' }}>
              {t.footer.tagline}
            </p>
            <div className={styles.socialRow}>
              {socialLinks.map((s, i) => (
                <a key={i} href={s.url} className={styles.socialBtn} aria-label={s.platform} target="_blank" rel="noreferrer">
                  {s.label}
                </a>
              ))}
            </div>
          </div>

          {/* Link columns */}
          {columns.map((col, i) => (
            <div key={i}>
              <h4 style={{ fontFamily: fonts.display, fontSize: 13, fontWeight: 700, color: '#fff', margin: '0 0 18px', letterSpacing: 1, textTransform: 'uppercase' }}>
                {col.title}
              </h4>
              {col.links.map((l, j) => (
                <Link key={j} to={l.to} className={styles.footerLink}>
                  {l.label}
                </Link>
              ))}
            </div>
          ))}
        </div>

        <div className={styles.bottom}>
          <span style={{ fontFamily: fonts.body, fontSize: 12, color: 'rgba(255,255,255,0.2)' }}>
            {brand.copyrightText}
          </span>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
